import {
  POST_FOLLOW_CALL_ORDERS_ORDER_REQUEST,
  POST_FOLLOW_CALL_ORDERS_ORDER_SUCCESS,
  POST_FOLLOW_CALL_ORDERS_ORDER_FAILURE,
  GET_FOLLOW_CALL_ORDER_LIST_REQUEST,
  GET_FOLLOW_CALL_ORDER_LIST_SUCCESS,
  GET_FOLLOW_CALL_ORDER_LIST_FAILURE,
  POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_REQUEST,
  POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_SUCCESS,
  POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_FAILURE,
  LOG_OUT_SUCCESS,
  INITIALIZE_MESSAGE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import { formatErrorMessage } from '../../utils/utils'

const initialState = {
  isPostingFollowCallOrder: false,
  message: '',
  errorMessage: '',
  pageInfo: {},
  followCallOrderList: [],
  isLoading: false,
  isPostingSalesforceSync: false,
};

export default (state = initialState, action) => {
  state = {
    ...state,
    successMessage: '',
  }

  switch (action.type) {
    case POST_FOLLOW_CALL_ORDERS_ORDER_REQUEST:
      return {
        ...state,
        isPostingFollowCallOrder: true,
      }
    case POST_FOLLOW_CALL_ORDERS_ORDER_SUCCESS:
      return {
        ...state,
        isPostingFollowCallOrder: false,
      }
    case POST_FOLLOW_CALL_ORDERS_ORDER_FAILURE: {
      const errorResponse = action.payload.error;

      // タイムアウトや通信断ではAPIのエラーメッセージを組み立てられないため、
      // action側で決めたメッセージをそのまま使う。
      // ApiClientがresponseを補完するのでerrorResponseは存在する。errorの有無では判定できない。
      if (action.payload.message) {
        return {
          ...state,
          isPostingFollowCallOrder: false,
          errorMessage: action.payload.message,
        }
      }

      // ここで無条件にerrorResponseを参照すると例外が投げられてstateが更新されず、
      // isPostingFollowCallOrderがtrueのまま固定されてボタンがローディングのまま止まってしまう。
      if (!errorResponse) {
        return {
          ...state,
          isPostingFollowCallOrder: false,
          errorMessage: errMessages.ERR_ORDER_FAILURE,
        }
      }

      let err = errorResponse.data && errorResponse.data.message;
      let message = '';

      if (typeof err === 'string') {
        message = err;
      } else if (err && typeof err === 'object') {
        // typeof null === 'object' のため、nullを除外しないとObject.valuesで例外になる
        Object.values(err).forEach((item) => {
          if (Array.isArray(item)) {
            message += item.join(' ')
          }
        });
      }

      return {
        ...state,
        isPostingFollowCallOrder: false,
        errorMessage: message ? [errMessages.ERR_ORDER_FAILURE, message] : errMessages.ERR_ORDER_FAILURE,
      }
    }
    case GET_FOLLOW_CALL_ORDER_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        message: '',
        errorMessage: '',
        pageInfo: {},
        followCallOrderList: [],
      }
    case GET_FOLLOW_CALL_ORDER_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        message: '',
        errorMessage: '',
        followCallOrderList: action.payload.data,
        pageInfo: action.payload.pageInfo,
      }
    case GET_FOLLOW_CALL_ORDER_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        message: '',
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    case POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_REQUEST:
      return {
        ...state,
        isPostingSalesforceSync: true,
        message: '',
        errorMessage: '',
      }
    case POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_SUCCESS:
      return {
        ...state,
        isPostingSalesforceSync: false,
        message: 'Salesforceに同期中。完了まで数分かかるので、後ほどご確認ください。',
        errorMessage: '',
      }
    case POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_FAILURE:
      return {
        ...state,
        isPostingSalesforceSync: false,
        message: '',
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_POST_SALESFORCE_SYNC_FAILURE),
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    case INITIALIZE_MESSAGE:
      return {
        ...state,
        message: initialState.message,
        errorMessage: initialState.errorMessage,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/followCallOrder.js